<template>
	<div class="cs-info-showcase" ref="csShowcase">
		<div class="cs-info-showcase--content">
			<div class="image-canvas primary-image">
				<AdvancedImage :image="image1"></AdvancedImage>
			</div>

			<div class="image-canvas secondary-image">
				<AdvancedImage :image="image2"></AdvancedImage>
			</div>
			<div class="cs-info--info">
				<IndexTitle
					v-if="heading"
					type="h3"
					index="01"
					:text="heading"
				/>
				<p v-if="excerpt" class="lead">
					{{ excerpt }}
				</p>
			</div>
		</div>
	</div>
</template>
<script>
// import Heading from '@/components/Heading';
import IndexTitle from '@/components/IndexTitle';
import AdvancedImage from '@/components/AdvancedImage';
import { useTransitionComposable } from '../../composables/transition-composable';
import { ref, watch, onUnmounted } from 'vue';
import { gsap } from 'gsap';

const { transitionState } = useTransitionComposable();

export default {
	name: 'CsShowcase',
	components: {
		// Heading,
		IndexTitle,
		AdvancedImage,
	},
	data() {
		return {
			inView: false,
		};
	},
	props: {
		heading: {
			type: String,
		},
		excerpt: {
			type: String,
		},
		image1: {
			type: Object,
			src: String,
			alt: String,
		},
		image2: {
			type: Object,
			src: String,
			alt: String,
		},
	},
	setup() {
		const csShowcase = ref(null);
		const viewable = ref(false);
		const ctx = ref();
		watch(
			[() => transitionState.transitionComplete, csShowcase],
			(newValue) => {
				if (newValue[0] == true && csShowcase.value) {
					const el = csShowcase.value;
					ctx.value = gsap.timeline({
						scrollTrigger: {
							trigger: el,
							// start: 'top 50%', // when the top of the trigger hits the top of the viewport
							start: 'top 30%',
						},
					});

					ctx.value.fromTo(
						el.querySelector(
							'.image-canvas.primary-image .advanced-image-wrapper',
						),
						{
							height: '0%',
						},
						{
							height: '100%',
							duration: 0.75,
						},
					);

					ctx.value.fromTo(
						el.querySelector(
							'.image-canvas.secondary-image .advanced-image-wrapper',
						),
						{
							height: '0%',
						},
						{
							height: '100%',
							duration: 0.75,
						},
						'-=0.25',
					);
					ctx.value.fromTo(
						el.querySelector('.cs-info--info'),
						{
							opacity: '0',
						},
						{
							opacity: 1,
							duration: 1,
						},
						'-=0.5',
					);
				}
			},
			{
				immediate: true,
			},
		);
		onUnmounted(() => {
			ctx.value.revert(); // <- Easy Cleanup!
		});
		return { csShowcase, viewable }; // WILL NOT WORK WITHOUT THIS
	},
};
</script>
